import AppUpload from '@/components/App/AppUpload.vue'

const Upload = {
  install(Vue) {
    this.EventBus = new Vue()
    Vue.component('app-upload', AppUpload)  
    Vue.prototype.$upload = {
      execute(params) {
        Upload.EventBus.$emit('execute', params)
      }
    }
  }
}

export default Upload